import React from 'react';
import styled from '@emotion/styled';
import ReactMarkdown from 'react-markdown';

const Container = styled.div`
  min-height: 100vh;
  background-color: #f5f5f7;
  padding: 2rem;
  display: flex;
  flex-direction: column;
`;

const Content = styled.div`
  max-width: 800px;
  margin: 0 auto;
  background: white;
  padding: 2rem;
  border-radius: 20px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  flex: 1;
`;

const Title = styled.h1`
  color: #1d1d1f;
  margin-bottom: 2rem;
  font-size: 2rem;
  text-align: center;
`;

const MarkdownContainer = styled.section`
  margin-bottom: 2rem;
  h1 {
    color: #1d1d1f;
    margin-bottom:0.5rem;
    font-size: 1.5rem;
  }
  h2 {
    color: #1d1d1f;
    margin-bottom: 0.5rem;
    font-size: 1.0rem;
  }

  p {
    color: #6e6e73;
    line-height: 1.6;
    margin-bottom: 0.5rem;
    font-size: 0.9rem;
  }

  ul, ol {
    color: #6e6e73;
    line-height: 1.6;
    margin-bottom: 0.5rem;
    padding-left: 1.5rem;
    font-size: 0.9rem;
  }

  ol {
    counter-reset: item;
  }

  ol > li {
    display: block;
    margin-bottom: 0.3rem;
    position: relative;
  }

  ol > li:before {
    content: counter(item) ". ";
    counter-increment: item;
    font-weight: bold;
    position: absolute;
    left: -1.5rem;
    width: 1.5rem;
    text-align: right;
  }

  ul > li {
    margin-bottom: 0.3rem;
  }
`;

const Footer = styled.footer`
  text-align: center;
  padding: 1rem 0;
  color: #86868b;
  font-size: 0.9rem;
`;

function CleanTextAiPrivacyPolicyJa() {
  const currentYear = new Date().getFullYear();
  const markdownContent = `
 # 이용약관

본 이용약관(이하 "본 약관")은 본 앱(이하 "본 서비스")의 이용 조건을 규정합니다. 사용자는 본 약관에 따라 본 서비스를 이용해야 합니다.

## 제1조(적용)

본 약관은 본 서비스 이용과 관련된 모든 관계에 적용됩니다. 본 서비스에 대해 개별 규정이 설정되어 있는 경우, 해당 개별 규정도 본 약관의 일부를 구성합니다. 개별 규정이 본 약관과 충돌하는 경우, 개별 규정이 우선합니다.

## 제2조(서비스 내용의 변경・종료)

본 서비스는 사전 통지 후 서비스 내용을 변경, 추가 또는 종료할 수 있습니다. 사용자는 이를 승낙하며, 내용 변경이나 종료와 관련된 손해에 대해 본 서비스는 책임을 지지 않습니다.

## 제3조(금지 사항)

사용자는 본 서비스 이용에 있어 다음과 같은 행위를 해서는 안 됩니다:

1. 법령 또는 공서양속에 반하는 행위
2. 범죄 행위와 관련된 행위
3. 본 서비스의 운영을 방해하는 행위
4. 제3자 또는 본 서비스의 지적재산권, 초상권, 프라이버시권, 기타 권리를 침해하는 행위
5. 다른 사용자의 개인정보를 수집 또는 축적하는 행위
6. 허위 정보를 제공하는 행위
7. 본 서비스의 시스템에 대한 무단 접근, 리버스 엔지니어링, 역컴파일, 역어셈블 등의 분석 행위
8. 스팸 행위나 본 서비스의 신뢰를 손상시키는 행위
9. 본 서비스의 네트워크나 시스템에 악영향을 미칠 가능성이 있는 행위
10. 본 서비스의 기능에 지장을 초래할 우려가 있는 소프트웨어 또는 코드를 사용하거나 의도적으로 확산하는 행위
11. 본 서비스 또는 제3자의 신용을 훼손하거나 명예를 훼손하는 행위
12. 본 약관 또는 본 서비스의 운영 정책을 위반하는 행위
13. 기타 본 서비스가 부적절하다고 판단하는 행위

## 제4조(서비스 제공의 중단 등)

본 서비스는 유지보수나 시스템 장애 등으로 인해 사전 통지 없이 제공을 일시 중단하거나 중지할 수 있습니다. 중단으로 인한 손해에 대해 본 서비스는 책임을 지지 않습니다.

## 제5조(보증의 부인 및 면책 사항)

1. 본 서비스는 사실상 또는 법률상의 하자(안전성, 신뢰성, 정확성 등)가 없음을 보증하지 않습니다.
2. 본 서비스로 인해 발생한 손해에 대해 본 서비스는 책임을 지지 않습니다.

## 제6조(지적재산권)

본 서비스의 내용과 디자인, 프로그램 등에 관한 저작권과 상표권 등의 지적재산권은 본 서비스 또는 정당한 권리를 가진 제3자에게 귀속됩니다. 사용자는 이를 무단으로 사용할 수 없습니다.

## 제7조(개인정보의 취급)

본 서비스는 사용자의 개인정보를 "개인정보 처리방침"에 따라 적절히 취급합니다.

## 제8조(권리의무의 양도 금지)

사용자는 본 서비스의 이용권을 제3자에게 양도, 전대 또는 담보로 제공할 수 없습니다.

## 제9조(통지)

본 서비스의 통지는 본 서비스 내 표시 또는 기타 적절하다고 인정되는 방법으로 이루어집니다. 통지 내용은 표시 후 즉시 효력이 발생합니다.

## 제10조(광고의 표시)

본 서비스는 사용자의 이용 환경에 광고를 표시할 수 있습니다.

## 제11조(이용약관의 변경)

1. 본 서비스는 본 약관을 사용자의 일반 이익에 적합하다고 판단하는 경우 또는 필요하다고 인정하는 경우에 변경할 수 있습니다.
2. 본 약관의 변경은 사전 통지되며, 통지 후 이용을 계속하는 경우 사용자는 변경된 약관에 동의한 것으로 간주됩니다.

## 제12조(부칙)

본 약관은 본 서비스 내에서 공표한 시점부터 적용됩니다.
  `;

  return (
    <Container>
      <Content>
        <Title>이용약관</Title>
        <MarkdownContainer>
          <ReactMarkdown>{markdownContent}</ReactMarkdown>
        </MarkdownContainer>
      </Content>
      <Footer>
        <p>© {currentYear} linappworks. All rights reserved.</p>
        <p>Contact us: linappworks@gmail.com</p>
      </Footer>
    </Container>
  );
}

export default CleanTextAiPrivacyPolicyJa; 